import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'daily_hours',
            label: i18n.t('labor.daily_hours_per_worker'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'weekly_overtime_hours',
            label: i18n.t('labor.weekly_overtime_hours_per_worker'),
            align: 'center',
            sortable: true,
        }
    ];
    return { tableColumns };
};

export default configTable;